// import { DotLottie } from '@lottiefiles/dotlottie-web';
// import '@lottiefiles/dotlottie-wc';
import '@aarsteinmedia/dotlottie-player-light'

// CUSTOM JS.

// Moved to parent theme.
// Add an optimized resize event.
// (function() {
// 	var throttle = function(type, name, obj) {
// 		obj = obj || window;
// 		var running = false;
// 		var func = function() {
// 			if (running) { return; }
// 			running = true;
// 				requestAnimationFrame(function() {
// 					obj.dispatchEvent(new CustomEvent(name))
// 					running = false;
// 			});
// 		};
// 		obj.addEventListener(type, func)
// 	};

// 	throttle("resize", "optimizedResize")
// })();
// Usage example: Recalculate on resize
// window.addEventListener("optimizedResize", function() {
// 	window.setTimeout( ()=>{
// 		console.log( 'optimized resize called!')
// 	}, 100)
// });



// Helper function, check if referrer is from the same origin.
// @see old one: https://stackoverflow.com/questions/4362761/how-can-i-determine-if-the-document-referrer-is-from-my-own-site.
function inzms_ib_check_referrer_same_origin() {
    try {
        const referrer = new URL(document.referrer);
        return (referrer.origin === location.origin);
    } catch(invalid_url_error) {
        return false;
    }
}




// Initial setup on Load.
// In order of need.
document.addEventListener('DOMContentLoaded', (event) => {
	console.log( 'JS child theme loaded.' )


	// Moved to parent theme.
	// const html = document.querySelector('html');
	// const body = document.querySelector('body');
	// html.classList.remove('no-js')
	// html.classList.add('js')


	// Replace video play buttons.
	const videoPlayButtons = document.querySelectorAll('.hd-bcve-wrapper .play-button')
	if (videoPlayButtons) {
		videoPlayButtons.forEach(element => {
			let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
			let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
			use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#ib_play_btn');
			svg.append(use)
			svg.classList.add('svg-icon')
			svg.setAttribute('aria-hidden', 'true')
			element.append(svg)
		})
	}



	// Add our Lottie animations.
	// Manually, because then we're independent of external js on load + the Lottie plugin doesn't work (and others are too commercial).

	// Note: Lottie moved from <dotlottie-player> to <dotlottie-player>-light (as this one renders as SVG by default, which is much sharper)
	// But: methods and properties are more basic (and documentation isn't complete and not entirely correct :/)

	// https://github.com/aarsteinmedia/dotlottie-player-light?tab=readme-ov-file#properties
	// https://github.com/aarsteinmedia/dotlottie-player-light?tab=readme-ov-file#properties
	// https://github.com/aarsteinmedia/dotlottie-player-light?tab=readme-ov-file#properties

	// Use as:

	// <dotlottie-player
	//   autoplay
	//   controls
	//   subframe
	//   loop
	//   src="https://storage.googleapis.com/aarsteinmedia/am.lottie"
	//   style="width: 320px; margin: auto;"
	// >
	// </dotlottie-player>
	//
	// const lottiePlayer = document.querySelector('dotlottie-player')
	// lottiePlayer.load('https://storage.googleapis.com/aarsteinmedia/am.lottie')

	// Docs dotlottie-web: https://developers.lottiefiles.com/docs/dotlottie-player/dotlottie-web/ (renders a canvas) & https://github.com/LottieFiles/dotlottie-web/tree/main/packages/web
	// Docs (deprecated) dotlottie-player-component: https://github.com/dotlottie/player-component

	const dotLottieLogo = document.querySelector('#dotLottieLogo img')
	if (dotLottieLogo) {
		// console.log('dotLottieLogo', dotLottieLogo);


		const dotLottieSrc = '/wp-content/themes/inzms-ib/assets/animations/IB_logo_animatie_300--dotLottie.lottie';
		// const dotLottieSrc = '/wp-content/themes/inzms-ib/assets/animations/IB_logo_animatie_300--LottieJSON.json';

		const dotLottieLogoPlayer = document.createElement('dotlottie-player');
		dotLottieLogoPlayer.setAttribute('width', '100px');
		dotLottieLogoPlayer.setAttribute('height', '100px');
		dotLottieLogoPlayer.id = 'dotLottieLogoCanvas';
		dotLottieLogoPlayer.setAttribute('src', dotLottieSrc);
		// dotLottieLogoPlayer.setAttribute('autoplay', 'autoplay');
		// dotLottieLogoPlayer.setAttribute('loop', 'loop');
		dotLottieLogo.insertAdjacentElement('afterend', dotLottieLogoPlayer);

		let dotLottieLogoAnimation = null;
		let stopCurrentAnimationAt = 59; // setSegments won't work in this svg version, we'll need to set end frames manually.

		// Animation is loaded and player is ready
		dotLottieLogoPlayer.addEventListener('ready', function (e) {
			// console.log('dotLottieLogoPlayer loaded');

			// Get the lottie-web instance used in the component, so we can use all interactivity features.
			dotLottieLogoAnimation = dotLottieLogoPlayer.getLottie();

			// Play the animation once.
			// console.log(dotLottieLogoPlayer); // <dotlottie-player id="dotLottieLogoCanvas" class="lottie-animation-canvas" width="100px" height="100px" src="/wp-content/themes/inzms…e_300--dotLottie.lottie" autoplay="autoplay">
			// console.log(dotLottieLogoAnimation); // Object { _cbs: [], name: "", path: "", isLoaded: true, currentFrame: 0, currentRawFrame: 0, firstFrame: 0, totalFrames: 60, frameRate: 30, frameMult: 0.03, … }

			// dotLottieLogoPlayer.toggleLoop()
			dotLottieLogoPlayer.play();


			// Add event listeners.
			// Listen for hovers: replay slowly how the logo grows.
			dotLottieLogoPlayer.addEventListener('mouseover', function (e) {
				// console.log('mouseover lottie logo animation instance');
				// console.log('dotLottieLogoPlayer.playerState: ' + dotLottieLogoPlayer.playerState);
				if (dotLottieLogoPlayer.playerState !== 'playing') {
					// console.log('dotLottieLogoPlayer is paused')
					dotLottieLogoPlayer.pause();
					dotLottieLogoPlayer.setSpeed(.5);
					// dotLottieLogoPlayer.setSegment([24, 36]); // cirkels zijn rond, logo groeit.
					dotLottieLogoPlayer.seek(54);
					stopCurrentAnimationAt = 56;
					dotLottieLogoPlayer.play();
				} else {
					// console.log('dotLottieLogoPlayer is still playing');
				}
			});

			// Listen for hover ends: finish the animation.
			dotLottieLogoPlayer.addEventListener('mouseout', function (e) {
				// console.log('mouseout lottie logo animation instance');
				dotLottieLogoPlayer.pause();
				// dotLottieLogoPlayer.setSegment([57, 60]) // frames start from 0.
				dotLottieLogoPlayer.seek(57);
				stopCurrentAnimationAt = 59;
				dotLottieLogoPlayer.play();
			});

			// Manually pause a 'segment'.
			dotLottieLogoPlayer.addEventListener('frame', function (e) {
				// console.log('playing frame ', dotLottieLogoAnimation.currentFrame);
				if (stopCurrentAnimationAt === dotLottieLogoAnimation.currentFrame) {
					dotLottieLogoPlayer.pause();
				}
			});

			// Always reset to normal speed + reset end frame.
			dotLottieLogoPlayer.addEventListener('complete', function (e) {
				dotLottieLogoPlayer.setSpeed(1);
				stopCurrentAnimationAt = 59;
			});

			// Tests.
			// dotLottieLogoPlayer.addEventListener('play', function (e) {
			// 	console.log('player started: ' + dotLottieLogoPlayer.getSegment() );
			// });
			// dotLottieLogoPlayer.addEventListener('complete', function (e) {
			// 	console.log('player complete');
			// });
			// dotLottieLogoPlayer.addEventListener('pause', function (e) {
			// 	console.log('player paused');
			// });

		});

		// Set our CSS classes (see _01_global.css).
		const dotLottieLogoWrapper = dotLottieLogo.parentElement
		dotLottieLogoWrapper.classList.add('lottie-animation-wrapper')
		dotLottieLogoPlayer.classList.add('lottie-animation-canvas')
		dotLottieLogo.classList.add('replaced-with-animation')


	}
})



